import { RouterProvider } from "react-router-dom";
import { useEffect, useLayoutEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { loadAppCustomizationsData, selectAppInfo, selectAppPersonalizations } from './services/utils/appInfoSlice';
import { checkUserAuth, selectAppAuth } from "./services/auth/authSlice";
import { App as NativeApp } from "@capacitor/app";
import { SplashScreen } from "@capacitor/splash-screen";
import { IS_NATIVE } from "./services/auth/nativeAuth";
import { ErrorBoundary } from "react-error-boundary";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './App.css'
import './components/Form.css'


//import app router from features
import {router} from './features/Router/appRouter'
import {Div} from "./components/Div";
import { loadGlobalFonts } from "./fonts/fonts";
import { updateOnlineDate } from "./features/User/userSlice";
import ErrorScreen from "./screens/ErrorScreen/ErrorScreen";
import MainLoader from "./screens/RootScreen/MainLoader";
import { setWebAppIdentity } from "./brand";
import { isMobile } from "react-device-detect";
import { sendTfEvent } from "./utils/utils";
import { checkForcedUpdate } from "./services/utils/appUpdate";
import { selectTranslations } from "./services/i18n/i18nSlice";
import { Button } from "./components/Button";


// Ass RouterProvider to the app
export default function App() {

  const dispatch = useDispatch();
  const userAuth = useSelector(selectAppAuth)
  const appInfo = useSelector(selectAppInfo)
  const personalizations = useSelector(selectAppPersonalizations)
  const [customizationsLoaded, setCustomizationsLoaded] = useState(false)
  // native only: store url when this version is below the minimum one, the app is then locked
  const [updateUrl, setUpdateUrl] = useState(null)
  const t = useSelector(selectTranslations)


  useEffect(()=>{
    //load customizations data for tenant
    dispatch(loadAppCustomizationsData()).then(data => {
      loadGlobalFonts()
      setCustomizationsLoaded(true)
    })
    // eslint-disable-next-line
  },[])

  // before the first paint (cached / brand colors), then again when the tenant ones arrive
  useLayoutEffect(()=>{
    document.documentElement.style.setProperty('--primary-color', personalizations?.primary_button?.background_color || '#436094');
    document.documentElement.style.setProperty('--link-color', personalizations?.link?.color || '#436094');
    setWebAppIdentity(personalizations)
  },[personalizations])

  useEffect(()=>{
    //load user data when token available
    if(userAuth.auth_token ){
        dispatch(updateOnlineDate())
    }
    // eslint-disable-next-line
  },[userAuth.auth_token])

  useEffect(()=>{
    //load user data when token available
    if(userAuth.refresh_auth && !userAuth.auth_token){
      dispatch(checkUserAuth())
    }
    console.log('Mobile Device: '+isMobile)

    if(isMobile && appInfo?.is_linked_to_app && !appInfo?.is_ofa)
      sendTfEvent({disableConfirmExit:true})
    // eslint-disable-next-line
  },[])

  useEffect(()=>{
    if(!IS_NATIVE) return
    // native: the splash goes away as soon as the app is mounted, from here on the app shows its own loaders
    SplashScreen.hide()
    const backButton = NativeApp.addListener('backButton', ({canGoBack}) => {
      canGoBack ? window.history.back() : NativeApp.exitApp()
    })
    // forced update: checked at start and every time the app comes back to the foreground
    checkForcedUpdate().then(setUpdateUrl)
    const resume = NativeApp.addListener('resume', () => checkForcedUpdate().then(setUpdateUrl))
    return () => {
      backButton.then(l => l.remove())
      resume.then(l => l.remove())
    }
    // eslint-disable-next-line
  },[])

  return (
    <Div id="App">
      <ToastContainer closeButton={false} hideProgressBar autoClose={3000}/>
      <ErrorBoundary fallback={<ErrorScreen />}>
        {/* the screens (login included) wait for the tenant settings: no flash of the wrong login / colors */}
        {updateUrl !== null ?
          <ErrorScreen error_title={t.error.update_title} error_text={t.error.update_text}>
            {updateUrl && <Button className="mt-3 mx-auto" onClick={() => window.open(updateUrl, '_blank')}>{t.error.update_button}</Button>}
          </ErrorScreen>
        : customizationsLoaded ? <RouterProvider router={router} /> : <MainLoader solid />}
      </ErrorBoundary>
    </Div>
  )
}


